import React from 'react';
import { Heart, Pill, HelpCircle } from 'lucide-react';

/**
 * Компонент раздела формы для параметров вычета на лечение
 */
const MedicalDeductionSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  medicalExpensesTypes 
}) => {
  return (
    <div className="mb-6 bg-red-50 dark:bg-red-900/20 p-4 rounded-lg border border-red-200 dark:border-red-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Heart className="w-5 h-5 mr-2 text-red-500" />
        Параметры вычета на лечение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Расходы на лечение */}
        <div>
          <label htmlFor="medicalExpenses" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Расходы на лечение и лекарства
          </label>
          <input
            type="text"
            id="medicalExpenses"
            name="medicalExpenses"
            value={formData.medicalExpenses}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.medicalExpenses ? 'input-error' : ''}`}
            placeholder="Введите сумму расходов"
          />
          {errors.medicalExpenses && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.medicalExpenses}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Для обычного лечения действует общий лимит социальных вычетов: 120 000 ₽
          </p>
        </div>

        {/* Тип медицинских расходов */}
        <div>
          <legend className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Тип медицинских услуг
          </legend>
          <div className="space-y-2">
            {medicalExpensesTypes.map(type => (
              <label key={type.id} className="flex items-center">
                <input
                  type="radio"
                  name="medicalExpensesType"
                  value={type.id}
                  checked={formData.medicalExpensesType === type.id}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  {type.name}
                  {type.id === 'expensive' && (
                    <span className="ml-1 inline-flex items-center px-2 py-0.5 text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 rounded-full">
                      Без лимита
                    </span>
                  )}
                </span>
              </label>
            ))}
          </div>
          {errors.medicalExpensesType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.medicalExpensesType}
            </p>
          )}
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 flex items-start p-3 bg-blue-50 dark:bg-blue-900/30 rounded-lg border border-blue-200 dark:border-blue-800">
        <HelpCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
            Важно знать о вычете на лечение
          </h4>
          <div className="text-xs text-blue-600 dark:text-blue-400">
            <p className="mb-1">
              Вычет на лечение предоставляется не только за свое лечение, но и за лечение родственников (супруги, родители, дети).
            </p>
            <p className="mb-1">
              <strong>Дорогостоящее лечение</strong> не имеет лимита. К нему относятся операции, протезирование, ЭКО и другие процедуры из перечня Правительства РФ. В медицинской справке должен стоять код "2" для такого лечения.
            </p>
            <p>
              <strong>Обычное лечение</strong> (код "1" в справке) входит в общий лимит социальных вычетов 120 000 ₽ в год вместе с расходами на обучение и другими социальными вычетами.
            </p>
          </div>
        </div>
      </div>

      {/* Перечень документов */}
      <div className="mt-4">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <Pill className="w-4 h-4 mr-2 text-red-500" />
          Необходимые документы:
        </h4>
        <ul className="text-xs text-gray-600 dark:text-gray-400 list-disc pl-5 space-y-1">
          <li>Договор на оказание медицинских услуг</li>
          <li>Лицензия медицинской организации</li>
          <li>Справка об оплате медицинских услуг (с указанием кода "1" или "2")</li>
          <li>Чеки, платежные поручения и другие документы, подтверждающие оплату</li>
          <li>Рецептурные бланки со штампом "Для налоговых органов" (для вычета за лекарства)</li>
          <li>Документы, подтверждающие родство (для лечения родственников)</li>
        </ul>
      </div>
    </div>
  );
};

export default MedicalDeductionSection;